/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';

import { iterUnpack } from '../../services/APIClient';

import SegmentClient from '../../services/SegmentClient';
import {
  ANALYTICS_NAME,
  PHONE_MODAL_HASH,
  BASE_URL,
} from './Constants';
import { UserResource } from '../../services/RESTClient';
import RequireRegisterPopup, { PERMISSION_TYPES } from '../RequireRegisterPopup';

const segment = new SegmentClient();
const userResource = new UserResource();
Modal.setAppElement('#root');

export default class BrandPhoneNumbersModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      slug: '',
      phoneNumbers: [],
      user: null,
      openRequireRegister: false,
      requireRegisterNext: null,
    };

    this.canContact = false;
    this.isLoadingUser = false;

    this.onOpenPhoneNumbersModalClick = this.onPhoneNumbersModalToggle.bind(this, 'open');
    this.onClosePhoneNumbersModalClick = this.onPhoneNumbersModalToggle.bind(this, 'close');
  }

  UNSAFE_componentWillMount() {
    // Get phone numbers from props
    const props = iterUnpack(JSON.parse(window.props));
    const {
      phoneNumbers,
      slug,
    } = props.allBrands[0];
    this.setState({
      phoneNumbers,
      slug,
    });
  }

  componentDidMount() {
    this.isLoadingUser = true;
    userResource.me()
      .then(user => this.setState({ user: user.data }))
      .catch(() => {})
      .finally(() => {
        this.isLoadingUser = false;
        this.canContact = userResource.canContactBrand();
        if (this.canContact) {
          if (window.location.hash === PHONE_MODAL_HASH) {
            this.onOpenPhoneNumbersModalClick();
          }
        } else if (window.location.hash === PHONE_MODAL_HASH) {
          this.setState(({ openRequireRegister: true }));
        }
      });
  }

  onPhoneNumbersModalToggle(method, e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ isOpen: method === 'open' }, () => {
      if (this.state.isOpen) {
        window.location.hash = PHONE_MODAL_HASH;
        return;
      }
      window.history.replaceState(null, document.title, window.location.href.replace(PHONE_MODAL_HASH, ''));
    });

    // Track the event in Segment
    if (method === 'open') segment.track(ANALYTICS_NAME.BRAND_TELEPHONE_BUTTON_CLICKED);
  }

  handlePhoneClick = (e) => {
    const { slug } = this.state;

    if (this.canContact) {
      this.onOpenPhoneNumbersModalClick(e);
    } else if (!this.isLoadingUser) {
      this.setState({
        openRequireRegister: true,
        requireRegisterNext: `/${BASE_URL}/${slug}/${PHONE_MODAL_HASH}`,
      });
    }
  }

  render() {
    return (
      <div>
        {/* Phone Numbers Button */}
        <a
          href={PHONE_MODAL_HASH}
          className="button secondary"
          onClick={this.handlePhoneClick}
        >
          <span className="material-icons fs-s" style={{ transform: 'scaleX(-1)' }}>
            phone
          </span>
        </a>

        {/* Phone Numbers Modal */}
        <Modal
          isOpen={this.state.isOpen}
          onRequestClose={this.onClosePhoneNumbersModalClick}
          className="reveal"
          overlayClassName="reveal-overlay"
          shouldCloseOnEsc
        >
          <div className="header">
            <div className="row">
              <div className="columns">
                <h4><strong>Phone Numbers</strong></h4>
              </div>
              <div className="columns shrink">
                <button
                  className="close-button light-gray"
                  onClick={this.onClosePhoneNumbersModalClick}
                  aria-label="Close modal"
                  type="button"
                >
                  <span aria-hidden="true" className="material-icons">close</span>
                </button>
              </div>
            </div>
          </div>
          {this.state.phoneNumbers.map(({ djangoId: id, type, number }) => (
            <div key={id} className="row">
              <div className="columns">
                <div className="row">
                  <div className="columns gray fs-s">
                    {type}
                  </div>
                </div>
                <div className="row mb-base">
                  <div className="columns">
                    <h3>{number}</h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className="footer">
            <div className="row align-center">
              <div className="small-3 columns">
                <button
                  className="small expanded button white fw-medium"
                  onClick={this.onClosePhoneNumbersModalClick}
                  type="button"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
        {this.state.openRequireRegister && (
          <RequireRegisterPopup
            permissionType={PERMISSION_TYPES.CONTACT}
            permissionDestinationUrl={`${window.location.href}${PHONE_MODAL_HASH}`}
            joinCompany
            waitForApprove
            onClose={() => {
              this.setState({ openRequireRegister: false });
              window.history.replaceState('', document.title, window.location.href.replace(PHONE_MODAL_HASH, ''));
            }}
            nextParam={this.state.requireRegisterNext}
          />
        )}
      </div>

    );
  }
}

ReactDOM.render(
  <BrandPhoneNumbersModal />,
  document.getElementById('phone-numbers-modal'),
);
